export const AttestationChainId = 42161;
// export const AttestationChainId = 11155111;
export const AttestationFee = BigInt(0.0007722 * 10 ** 18);
export const FeeExemptAttestationsLimit = 30;